import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Chip,
  IconButton,
  Divider,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { get, isEmpty } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import ILineItem, {
  ILineItemSubSelection,
} from '../../../models/LineItem.model';
import { IOrder } from '../../../models/Order.model';
import {
  collectSubProducts,
  getCurrencyPrefix,
} from '../../../services/Util/Util.service';

import './OrderDetailsDialog.scss';

interface IOrderDetailsDialogProps {
  onClose: () => void;
  order: IOrder;
}

const OrderDetailsDialog = (props: IOrderDetailsDialogProps) => {
  const { order, onClose } = props;
  console.log({ order });

  const [PhoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    if (!isEmpty(get(order, 'user'))) {
      const phoneNumber = getInternationalPhoneNumber();
      setPhoneNumber(phoneNumber);
    }
  }, [order]);

  const getInternationalPhoneNumber = () => {
    const PNF = require('google-libphonenumber').PhoneNumberFormat;
    const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
    const phone = phoneUtil.parseAndKeepRawInput(
      '+' +
        get(order, 'user.countryCode', '') +
        get(order, 'user.phoneNumber', ''),
      '',
    );
    return phoneUtil.format(phone, PNF.INTERNATIONAL);
  };
  return (
    <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth="sm">
      <DialogTitle>
        <span className="section-title">Order Details - #{order.orderNo}</span>
        <IconButton
          aria-label="close"
          className="close-icon-button"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container={true} justify="flex-start">
          {!isEmpty(get(order, 'user')) && (
            <>
              <div className="line-item-headers">
                <Typography variant="h5" className="line-item-headers__item">
                  Customer Details
                </Typography>
                <Typography
                  variant="h5"
                  className="line-item-headers__price"
                ></Typography>
              </div>
              <Grid container={true} justify="flex-start">
                <Grid item={true} xs={8}>
                  <div className="line-item-details-section">
                    <div className="line-item-details__item-name">Name</div>
                  </div>
                </Grid>
                <Grid item={true} xs={4}>
                  <div className="line-item-details-section pricing">
                    <div className="line-item-pricing">
                      {`${get(order, 'user.firstName', '')} ${get(
                        order,
                        'user.lastName',
                        '',
                      )}`}
                    </div>
                  </div>
                </Grid>
                <Grid item={true} xs={8}>
                  <div className="line-item-details-section">
                    <div className="line-item-details__item-name">Phone</div>
                  </div>
                </Grid>
                <Grid item={true} xs={4}>
                  <div className="line-item-details-section pricing">
                    <div className="line-item-pricing">{PhoneNumber}</div>
                  </div>
                </Grid>
                <Grid item={true} xs={8}>
                  <div className="line-item-details-section">
                    <div className="line-item-details__item-name">Email</div>
                  </div>
                </Grid>
                <Grid item={true} xs={4}>
                  <div className="line-item-details-section pricing">
                    <div className="line-item-pricing">
                      {get(order, 'user.email', '')}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          )}

          <hr />

          {!isEmpty(get(order, 'event')) && (
            <>
              <div className="line-item-headers">
                <Typography
                  variant="h5"
                  className="line-item-headers__customer"
                >
                  Event
                </Typography>
              </div>
              <div className="customer-details-section">
                <div className="customer-detail">
                  {get(order, 'event.name', '')}
                </div>
              </div>
            </>
          )}
          {!isEmpty(get(order, 'note')) && (
            <>
              <div className="customer-details-section">
                {' '}
                {/* Corrected class name */}
                <div className="customer-detail">
                  Note: {get(order, 'note', '')}
                </div>
              </div>
            </>
          )}

          <div className="line-item-headers">
            <Typography variant="h5" className="line-item-headers__item">
              Item(s)
            </Typography>
            <Typography variant="h5" className="line-item-headers__price">
              Cost
            </Typography>
          </div>
          {!isEmpty(order) &&
            order.lineItems.map((lineItem: ILineItem) => {
              // tslint:disable-next-line: prefer-const
              let subProducts: ILineItemSubSelection[] = [];
              collectSubProducts(lineItem.subSelections || [], subProducts);

              return (
                <Fragment key={lineItem.id}>
                  <Grid key={lineItem.id} item={true} xs={8}>
                    <div className="line-item-details-section">
                      <div className="line-item-details__item-name">
                        {lineItem.quantity >= 1 ? (
                          <div>
                            {lineItem.product.name} x{lineItem.quantity}
                            {lineItem.quantityRefunded > 0 && (
                              <span
                                style={{
                                  color: '#e33b3b',
                                  textDecoration: 'line-through',
                                  fontSize: '1.1rem',
                                }}
                              >
                                (Refunded x{lineItem.quantityRefunded})
                              </span>
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              color: '#e33b3b',
                              textDecoration: 'line-through',
                              fontSize: '1.1rem',
                            }}
                          >
                            {lineItem.product.name} (x
                            {lineItem.quantityRefunded})
                          </div>
                        )}
                        {subProducts.length > 0 && (
                          <div>
                            {subProducts.map(
                              (sp: ILineItemSubSelection, ii: number) => {
                                const category = lineItem.subSelections.find(
                                  (ss: ILineItemSubSelection) =>
                                    ss.id === sp.parentId,
                                );
                                let refundedProductCount = 0;
                                let refundedSubProductPrice = 0;
                                lineItem?.refundSubProducts?.map(e => {
                                  if (e?.productId === sp.productId) {
                                    refundedProductCount += e.quantity;
                                    refundedSubProductPrice +=
                                      e.quantity * e.price;
                                  }
                                });

                                const displayName =
                                  refundedProductCount > 0
                                    ? `${sp.name} (Refunded x ${refundedProductCount})`
                                    : sp.name;
                                if (
                                  sp.quantity *
                                    (lineItem.quantity +
                                      lineItem.quantityRefunded) -
                                    refundedProductCount === // Corrected comparison
                                  0
                                ) {
                                  return (
                                    <p
                                      className="line-item-details__combo-details"
                                      style={{
                                        color: '#e33b3b',
                                        textDecoration: 'line-through',
                                      }}
                                      key={ii}
                                    >
                                      {`${category ? `${category.name}: ` : ''}
                                      ${sp.name} x${refundedProductCount}
                                      `}
                                    </p>
                                  );
                                } else {
                                  return (
                                    <p
                                      className="line-item-details__combo-details"
                                      key={ii}
                                    >
                                      {`${
                                        category ? `${category.name}: ` : ''
                                      }${displayName}${
                                        sp.quantity > 1
                                          ? ` (x${sp.quantity})`
                                          : ''
                                      }`}
                                    </p>
                                  );
                                }
                              },
                            )}
                          </div>
                        )}
                        {lineItem.instructions && (
                          <div className="line-item-details__instructions">
                            - {lineItem.instructions}
                          </div>
                        )}
                      </div>
                    </div>
                  </Grid>
                  <Grid key={`${lineItem.id}_pricing`} item={true} xs={4}>
                    <div className="line-item-details-section pricing">
                      <div
                        className="line-item-pricing"
                        style={{
                          color: lineItem.quantity > 0 ? '' : '#e33b3b',
                        }}
                      >
                        <NumberFormat
                          value={lineItem.product.price * lineItem.quantity}
                          decimalScale={2}
                          displayType={'text'}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          prefix={getCurrencyPrefix(order.currency)}
                        />
                      </div>

                      {subProducts.length > 0 && (
                        <div>
                          {subProducts.map(
                            (sp: ILineItemSubSelection, ii: number) => {
                              let refundedProductCount = 0;
                              let refundedSubProductPrice = 0;
                              lineItem?.refundSubProducts?.map(e => {
                                if (e?.productId === sp.productId) {
                                  refundedProductCount += e.quantity;
                                  refundedSubProductPrice +=
                                    e.quantity * e.price;
                                }
                              });

                              let displayPrice = (
                                +sp.price *
                                  (+lineItem.quantity +
                                    +lineItem.quantityRefunded) -
                                +refundedSubProductPrice
                              ).toFixed(2);
                              return (
                                <p
                                  className="line-item-details__combo-details"
                                  key={ii}
                                  style={{
                                    color:
                                      sp.quantity *
                                        (lineItem.quantity +
                                          lineItem.quantityRefunded) -
                                        refundedProductCount ===
                                      0 // Corrected condition
                                        ? '#e33b3b'
                                        : '',
                                  }}
                                >
                                  {`${getCurrencyPrefix(
                                    order.currency,
                                  )}${displayPrice}`}
                                </p>
                              );
                            },
                          )}
                        </div>
                      )}
                    </div>
                  </Grid>
                </Fragment>
              );
            })}
          {!isEmpty(get(order, 'instructions', '')) && (
            <div className="order-notes">
              NOTES: {get(order, 'instructions', '')}
            </div>
          )}
        </Grid>

        <hr />

        <div className="summary-container">
          <Grid container spacing={0}>
            {/* Promotions section - Left column */}
            <Grid item xs={6} className="promotions-column">
              {Array.isArray(order.orderPromotions) &&
                order.orderPromotions.length > 0 && (
                  <div className="promotions-applied-section">
                    <Typography
                      variant="h6"
                      className="promotions-applied-header"
                    >
                      Promotions Applied
                    </Typography>
                    <div className="promotions-applied-grid">
                      {order.orderPromotions.map((op, index) => {
                        const definedValue =
                          op.promotion.discountAmount > 0
                            ? `${getCurrencyPrefix(
                                order.currency,
                              )}${op.promotion.discountAmount.toFixed(2)}`
                            : `${op.promotion.discountPercentage}%`;
                        const appliedValue = `${getCurrencyPrefix(
                          order.currency,
                        )}${op.discountAmt.toFixed(2)}`;
                        return (
                          <div key={index} className="promotion-tag-container">
                            <div className="promotion-tag">
                              {op.promotion.code} ({definedValue} →{' '}
                              {appliedValue})
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
            </Grid>

            {/* Vertical divider */}
            {Array.isArray(order.orderPromotions) &&
              order.orderPromotions.length > 0 && (
                <div className="vertical-divider"></div>
              )}

            {/* Pricing details section - Right column */}
            <Grid item xs={6} className="pricing-column">
              <div className="pricing-details-section">
                <div className="individual-pricing">
                  <div className="pricing-units">Subtotal:</div>
                  <div className="pricing-values">
                    {!isEmpty(order) && (
                      <NumberFormat
                        value={order.subTotal}
                        decimalScale={2}
                        displayType={'text'}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix={getCurrencyPrefix(order.currency)}
                      />
                    )}
                  </div>
                </div>
                <div className="individual-pricing">
                  <div
                    className={`pricing-units ${
                      get(order, 'discountAmt') === 0 ? '' : 'discount'
                    }`}
                  >
                    Discount:
                  </div>
                  <div
                    className={`pricing-values ${
                      get(order, 'discountAmt') === 0 ? '' : 'discount'
                    }`}
                  >
                    {!isEmpty(order) && (
                      <>
                        {get(order, 'discountAmt') === 0 ? null : (
                          <span>-</span>
                        )}
                        <NumberFormat
                          value={order.discountAmt}
                          decimalScale={2}
                          displayType={'text'}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          prefix={getCurrencyPrefix(order.currency)}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="individual-pricing">
                  <div className="pricing-units nowrap">
                    Convenience Charges:
                  </div>
                  <div className="pricing-values">
                    {!isEmpty(order) && (
                      <NumberFormat
                        value={order.convenienceFee}
                        decimalScale={2}
                        displayType={'text'}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix={getCurrencyPrefix(order.currency)}
                      />
                    )}
                  </div>
                </div>
                <div className="individual-pricing">
                  <div className="pricing-units">Service Charge:</div>
                  <div className="pricing-values">
                    {!isEmpty(order) && (
                      <NumberFormat
                        value={order.serviceFee}
                        decimalScale={2}
                        displayType={'text'}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix={getCurrencyPrefix(order.currency)}
                      />
                    )}
                  </div>
                </div>
                <div className="individual-pricing">
                  <div className="pricing-units">Tip:</div>
                  <div className="pricing-values">
                    {!isEmpty(order) && (
                      <NumberFormat
                        value={order.tipAmt}
                        decimalScale={2}
                        displayType={'text'}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix={getCurrencyPrefix(order.currency)}
                      />
                    )}
                  </div>
                </div>
                {order.taxCalculated && (
                  <div className="individual-pricing">
                    <div className="pricing-units">Tax:</div>
                    <div className="pricing-values">
                      {!isEmpty(order) && (
                        <NumberFormat
                          value={order.taxAmt}
                          decimalScale={2}
                          displayType={'text'}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          prefix={getCurrencyPrefix(order.currency)}
                        />
                      )}
                    </div>
                  </div>
                )}
                <div className="individual-pricing">
                  <div className="pricing-units total">Total:</div>
                  <div className="pricing-values total">
                    {!isEmpty(order) && (
                      <NumberFormat
                        value={order.total}
                        decimalScale={2}
                        displayType={'text'}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix={getCurrencyPrefix(order.currency)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

OrderDetailsDialog.defaultProps = {
  isOrderCompleted: false,
};

export default OrderDetailsDialog;
